// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupVideoCallHeader__info-fdf3bf {
  flex: 1 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  margin-inline-end: auto;
}

.GroupVideoCallHeader__group-title-fc2956 {
  color: var(--addition-50);
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.GroupVideoCallHeader__call-state-f2b48a {
  color: var(--addition-50);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body);
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
}

.GroupVideoCallHeader__button-fc0d9e {
  margin-inline-start: 16px;
  order: 2;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/CompactCallView/GroupVideoCall/GroupVideoCallHeader/GroupVideoCallHeader.styles.m.css"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;AACF;;AAEA;EACE,yBAAA;EACA,wBAAA;EACA,0CAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,yBAAA;EACA,wBAAA;EACA,wCAAA;EAEA,mBAAA;EACA,kBAAA;EACA,uBAAA;EAEA,aAAA;EACA,mBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,QAAA;AAFF","sourcesContent":[".info {\n  flex: 1 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  margin-inline-end: auto;\n}\n\n.group-title {\n  color: var(--addition-50);\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.call-state {\n  color: var(--addition-50);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body);\n\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n\n  display: flex;\n  align-items: center;\n}\n\n.button {\n  margin-inline-start: 16px;\n  order: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"info": `GroupVideoCallHeader__info-fdf3bf`,
	"group-title": `GroupVideoCallHeader__group-title-fc2956`,
	"groupTitle": `GroupVideoCallHeader__group-title-fc2956`,
	"call-state": `GroupVideoCallHeader__call-state-f2b48a`,
	"callState": `GroupVideoCallHeader__call-state-f2b48a`,
	"button": `GroupVideoCallHeader__button-fc0d9e`
};
module.exports = ___CSS_LOADER_EXPORT___;
